import React, {useEffect, useState} from 'react';
import axios from 'axios';
import {Link} from 'react-router-dom';
import DOMPurify from "dompurify";

const Faq = () => {
    const backendBaseUrl = process.env.REACT_APP_BACKEND_BASE_URL;
    const [faqCategories, setFaqCategories] = useState([]);
    const [loading, setLoading] = useState(true);
    useEffect(() => {
        const fetchFaqs = async () => {
            const apiBaseUrl = process.env.REACT_APP_API_BASE_URL;
            const Url = process.env.REACT_APP_API_FAQ;
            try {
                const response = await axios.get(`${apiBaseUrl}${Url}`);
                setFaqCategories(response.data);
            } catch (error) {
                console.error('Failed to fetch Faqs:', error);
            }
        };
        fetchFaqs();
    }, []);


    return (
        <main className="main">
            <div className="site-breadcrumb" style={{ backgroundImage: `url(${process.env.PUBLIC_URL}/assets/img/breadcrumb/01.jpg)`}}>
                <div className="container">
                    <h2 className="breadcrumb-title">আপনাদের জিজ্ঞাসিত প্রশ্নাবলী</h2>
                    <ul className="breadcrumb-menu">
                        <li>
                            <Link className="nav-link" to={"/"}>হোম</Link>
                        </li>
                        <li className="active">আপনাদের জিজ্ঞাসিত প্রশ্নাবলী</li>
                    </ul>
                </div>
            </div>

            <div className="faq-area pt-100 pb-80">
                <div className="container">
                    <div className="row">
                        {faqCategories?.map((category, catIndex) => (
                            <div className="col-lg-6 my-2" key={catIndex}>
                                <div className="card">
                                    <div className="card-header text-center" style={{backgroundColor:'#E95A30'}}>
                                        <h5 className={'fw-bold text-white'}>{category?.name_bangla}</h5>
                                    </div>
                                    <div className="card-body">
                                        <div className="accordion wow fadeInRight" data-wow-delay=".25s" id={`accordionExample${catIndex}`}>
                                            {category.faqs?.map((faq, index) => (
                                                <div className="accordion-item" key={index}>
                                                    <h5 className="accordion-header" id={`heading-${catIndex}-${index}`}>
                                                        <button className="accordion-button text-dark" style={{fontSize:'15px'}} type="button" data-bs-toggle="collapse"
                                                                data-bs-target={`#collapse-${catIndex}-${index}`} aria-expanded={index === 0}
                                                                aria-controls={`collapse-${catIndex}-${index}`}>
                                                            <span><i className="far fa-question"></i></span> {faq.question}
                                                        </button>
                                                    </h5>
                                                    <div id={`collapse-${catIndex}-${index}`} className={`accordion-collapse collapse`}
                                                         aria-labelledby={`heading-${catIndex}-${index}`} data-bs-parent={`#accordionExample${catIndex}`}>
                                                        <div className="accordion-body">
                                                            <div className="site-heading mb-3" dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(faq.answer) }}>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            ))}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        ))}
                    </div>
                </div>
            </div>
        </main>

    );
};

export default Faq;
